import { render } from "./AdminClientsView.vue?vue&type=template&id=283d09ff&scoped=true"
import script from "./AdminClientsView.vue?vue&type=script&lang=js"
export * from "./AdminClientsView.vue?vue&type=script&lang=js"

import "./AdminClientsView.vue?vue&type=style&index=0&id=283d09ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283d09ff"]])

export default __exports__